import { Badge, BadgeProps } from "@mantine/core";
import { SupportTicketStatus } from "@/app/@types/support";
import { SUPPORT_STATUSES } from "@/app/_constants/support";

interface SupportStatusBadgeProps extends Omit<BadgeProps, "color"> {
  status: SupportTicketStatus;
}

const SupportStatusBadge = ({ status, ...rest }: SupportStatusBadgeProps) => {
  const meta = SUPPORT_STATUSES[status] ?? SUPPORT_STATUSES.open;
  return (
    <Badge color={meta.color} variant="light" radius="sm" {...rest}>
      {meta.label}
    </Badge>
  );
};

export default SupportStatusBadge;
